import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppointmentList, DemandListDownload } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { InvoiceService } from 'projects/Administration/src/app/business-services/invoice.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CookieService } from 'ngx-cookie-service';
import { CultureLocaleService } from 'projects/Administration/src/app/services/culture-locale.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { DocumentWarnings, ServiceRemarks } from 'projects/Administration/src/app/business-entities/invoice-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import * as Enums from '../../../../../../../Autofacets-Core/src/app/utils/enums';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { CustomerService } from 'projects/Administration/src/app/business-services/customer.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';

@Component({
  selector: 'app-invoice-warning-popup',
  templateUrl: './invoice-warning-popup.component.html',
  styleUrls: ['./invoice-warning-popup.component.css']
})
export class InvoiceWarningPopupComponent implements OnInit {
  @Input() appointmentDetails: AppointmentList;
  licensePlateClass: string;
  documentWarnings: DocumentWarnings[];
  serviceRemarks: ServiceRemarks[];
  isAllowToGenerate: boolean = false;
  generatedResponse:string = "";
  features: Features[] = [];
  trustedBlobUrl: SafeResourceUrl;
  selectedCustomers: DemandListDownload[] = [];
  groupedDemandList: DemandListDownload[];
  dropdownSettings = {
    singleSelection: false,
    idField: 'customerNo',
    textField: 'customerNo',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 5,
    allowSearchFilter: false,
    searchPlaceholderText: 'Search here',
    maxHeight: 500
  };
  constructor(
    private globalSetting: GlobalSetting,
    private activeModal: NgbActiveModal,
    private service: InvoiceService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private cookieservice: CookieService,
    private secureStorage: SecureStorage,
    private userService: UserDataService,
    private customerService: CustomerService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    public editAppointmentService: EditAppointmentService,
    private appointmentService: AppointmentService,
    public cultureLocaleService: CultureLocaleService,) { }

  async ngOnInit(): Promise<void> {
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.spinner.show();
    await this.GetServiceDetail();
    await this.onGetDocumentWarnings();
    this.spinner.hide();
    this.generatedResponse = "";
  }

  async onGetDocumentWarnings() {
    let LanguageCode = this.cookieservice.get('userSelectedLanguage');
    let wo = this.appointmentDetails.workOrderNo;
    await this.service.getDocumentWarning(wo, LanguageCode).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        if (response.responseObject.isSuccess) {
          this.documentWarnings = response.responseObject.documentWarnings;
          this.serviceRemarks = response.responseObject.serviceRemarks;
          if (this.documentWarnings.length > 0 ) {
            let index = this.documentWarnings.findIndex(f => f.category == "Error");
            if (index == -1) {
              this.GenerateOrPreviewInvoice();
            }
          }else{
            this.GenerateOrPreviewInvoice();
          }
        }
        else {
          this.toaster.error(response.responseObject.resultMessage);
        }
      }
    });
  }

  private GenerateOrPreviewInvoice() {
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        let isInvoice = this.features.find(x => x.featureCode === Enums.FeatureCode.INVGN)?.isActive;
        if (isInvoice && this.userService?.currentUserValue?.userRoleMenuDetails?.find(x => x.moduleId === Enums.ModuleNames.AllowInvoiceFeature)?.canEdit) {
          this.isAllowToGenerate = true;
        }
      }
    }
  }

  OnClose() {
    this.activeModal.dismiss(false);
  }

  async OnGenerateInvoice() {
    this.spinner.show();
    this.generatedResponse = "";
    let LanguageCode = this.cookieservice.get('userSelectedLanguage');
    let wo = this.appointmentDetails.workOrderNo;
    let viewModel = {
      appointmentId: this.appointmentDetails.id,
      customers: this.selectedCustomers?.map(x => x.customerNo),
      ifsWorkOrderNumber: wo,
      isInvoice: true,
      isShip: true,
      languageCode: LanguageCode,
      userId: "",
      moduleId: 0
    }
    await this.service.GenerateInvoice(viewModel).then((response) => {
      this.spinner.hide();
      this.generatedResponse = response.responseObject.resultMessage;
      if (response.responseCode === Constant.SuccessResponseCode) {
        if (response.responseObject.isSuccess) {
          this.toaster.success(response.responseObject.resultMessage);
          this.spinner.hide();
          this.activeModal.close({
            success: true
          });
        }
        else {
          this.toaster.error(response.responseObject.resultMessage);
          this.spinner.hide();
        }
      }
    },
      _error => {
        this.spinner.hide();
      });
  }
  
  async GetServiceDetail() {
    this.groupedDemandList = [];
    const languageCode = this.cookieservice.get('userSelectedLanguage');
    await this.appointmentService.GetServiceDetail(this.editAppointmentService.appointmentDetails.id, '', languageCode).then(data => {
      if (data.responseObject != null && data.responseObject.appointmentDemandList.length > 0) {
        this.groupedDemandList = this.mapData(data.responseObject.appointmentDemandList);
        const deafultBillToCustomerIndex = this.groupedDemandList.findIndex(x => x.customerNo === this.appointmentDetails.billtoCustomerNo);
        if (deafultBillToCustomerIndex >= 0) {
          this.selectedCustomers = [this.groupedDemandList[deafultBillToCustomerIndex]];
        }
      }
    });
  }

  mapData(data: any) {
    let supperArray = [];
    if (data && data.length > 0) {
      data.forEach(element => {
        if(!supperArray.find(x=>x.customerNo == element.billToCustomer))
        {
          let single = Object();
          single.customerNo = element.billToCustomer
          supperArray.push(single);
        }
      })
    }
    return supperArray;
  }

  async onPreviewInvoice(content) {
    this.spinner.show();
    let LanguageCode = this.cookieservice.get('userSelectedLanguage');
    let viewModel = {
      appointmentId: this.appointmentDetails.id,
      customers: this.selectedCustomers?.map(x => x.customerNo),
      ifsWorkOrderNumber: this.appointmentDetails.workOrderNo,
      languageCode: LanguageCode,
      userId: "",
      moduleId: 0
    }
    await this.service.getInvoicePreview(viewModel).then((response) => {
      this.spinner.hide();
      if (response.responseCode === Constant.SuccessResponseCode) {
        this.onPreview(content, response.responseObject.fileContents);
      }else{
        this.toaster.error(response.responseMessage);
        this.spinner.hide();
      }
    },
      _error => {
        this.spinner.hide();
      });
  }
  
  async onPreview(content, base64String: string) {
        if (base64String) {
          let blob = Utility.base64toBlob(base64String, "application/pdf;charset=utf-8");
          this.trustedBlobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob) + '#toolbar=0');
    
          this.modalService
          .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' })
          .result;
        }
      }
}
